module.exports = __webpack_public_path__ + "static/img/money-02-nobg.2bb4205.png";